/**
 * @file コンポーネント：フル動画ページコントローラー DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Tab } from "~/src/components/projects/Tab";
import { Timeline } from "~/src/components/projects/Video/Timeline";
import { Loading } from "~/src/components/uiparts/Loading";

// スタイル読み込み
import { StyledController, StyledControllerLoading } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledController>
            {props.isLoadingContentsController === true && (
                // ローディング中
                <StyledControllerLoading>
                    <Loading />
                </StyledControllerLoading>
            )}
            <Tab
                list={[
                    // タイムライン
                    {
                        content: [
                            <Timeline
                                setIsOpenModalLogin={props.setIsOpenModalLogin}
                                fnJump={props.fnJump}
                                fnSetModalEdit={props.fnSetModalEdit}
                                isEditPage={props.isEditPage}
                                isLoadingTimeline={props.isLoadingTimeline}
                                isPaid={props.isPaid}
                                isPurchased={props.isPurchased}
                                isShow={
                                    props.selectedTabController === "timeline"
                                }
                                key="timeline"
                                languageCodeOperation={
                                    props.languageCodeOperation
                                }
                                listTimeline={props.listTimeline}
                                mainSurgeonId={props.mainSurgeonId}
                                setClickedSlideIndex={
                                    props.setClickedSlideIndex
                                }
                                setIsHighlightPopupPayment={
                                    props.setIsHighlightPopupPayment
                                }
                                setIsOpenPopupSchema={
                                    props.setIsOpenPopupSchema
                                }
                                setPopupSchemaSlider={
                                    props.setPopupSchemaSlider
                                }
                                setSelectedContentsData={
                                    props.setSelectedContentsData
                                }
                                timeProgress={props.timeProgress}
                                type="comment"
                                operationId={props.operationId}
                            />,
                        ],
                        name: "timeline",
                        triggerIcon: <i className="fas fa-clock"></i>,
                        triggerText: localized["Label.Timeline"],
                    },
                    // イベントリスト
                    {
                        content: [
                            <Timeline
                                setIsOpenModalLogin={props.setIsOpenModalLogin}
                                fnJump={props.fnJump}
                                fnSetModalEdit={props.fnSetModalEdit}
                                isEditPage={props.isEditPage}
                                isLoadingTimeline={props.isLoadingTimeline}
                                isShow={
                                    props.selectedTabController === "eventlist"
                                }
                                key="eventlist"
                                languageCodeOperation={
                                    props.languageCodeOperation
                                }
                                listTimeline={props.listEvent}
                                mainSurgeonId={props.mainSurgeonId}
                                setClickedSlideIndex={
                                    props.setClickedSlideIndex
                                }
                                setIsOpenPopupSchema={
                                    props.setIsOpenPopupSchema
                                }
                                setPopupSchemaSlider={
                                    props.setPopupSchemaSlider
                                }
                                setSelectedContentsData={
                                    props.setSelectedContentsData
                                }
                                timeProgress={props.timeProgress}
                                type="event"
                            />,
                        ],
                        hasContent: props.isEditPage === true,
                        name: "eventlist",
                        triggerIcon: <i className="fas fa-flag"></i>,
                        triggerText: localized["Label.Event"],
                    },
                ]}
                onColor="sub"
                selectedTab={props.selectedTabController}
                setSelectedTab={props.setSelectedTabController}
            />
        </StyledController>
    );
};
